export const DASHBOARD_LIST_REQUEST = "DASHBOARD_LIST_REQUEST";
export const DASHBOARD_LIST_SUCCESS = "DASHBOARD_LIST_SUCCESS";
export const DASHBOARD_LIST_FAIL = "DASHBOARD_LIST_FAIL";

export const DASHBOARD_DETAILS_REQUEST = "DASHBOARD_DETAILS_REQUEST";
export const DASHBOARD_DETAILS_SUCCESS = "DASHBOARD_DETAILS_SUCCESS";
export const DASHBOARD_DETAILS_FAIL = "DASHBOARD_DETAILS_FAIL";